import {
  AdoptionReportAttribute,
  AdoptionReportMetric,
} from "types/graphql-schema";

import { UseLabelType } from "@apps/use-label/use-label";

export const attributeLabels: { [key in AdoptionReportAttribute]: string } = {
  [AdoptionReportAttribute.Name]: "Name",
  [AdoptionReportAttribute.Email]: "Email",
  [AdoptionReportAttribute.LastSeen]: "Last activity",
  [AdoptionReportAttribute.ManagerEmail]: "Manager email",
  [AdoptionReportAttribute.ManagerName]: "Manager name",
};
export const metricLabels = (
  label: UseLabelType,
): { [key in AdoptionReportMetric]: string } => ({
  [AdoptionReportMetric.OneononeMeetingsAsManager]: "1-on-1s as manager",
  [AdoptionReportMetric.OneononeMeetingsAsParticipant]:
    "1-on-1s as participant",
  [AdoptionReportMetric.GoalsCreated]: `${label("goal", {
    capitalize: true,
    pluralize: true,
  })} created`,
  [AdoptionReportMetric.GoalUpdates]: `${label("goal", {
    capitalize: true,
  })} updates`,
  [AdoptionReportMetric.CareerGoalUpdates]: `Career ${label("goal")} updates`,
  [AdoptionReportMetric.RecognitionsGiven]: `${label("recognition", {
    capitalize: true,
    pluralize: true,
  })} given`,
  [AdoptionReportMetric.RecognitionsReceived]: `${label("recognition", {
    capitalize: true,
    pluralize: true,
  })} received`,
  [AdoptionReportMetric.AssessmentsAsTarget]: `${label("review", {
    pluralize: true,
    capitalize: true,
  })} received`,
  [AdoptionReportMetric.ActionItemsCreated]: "Action items created",
});

export const getManagerEffectivenessAnswerPercentage = (
  question: { startValue: number; endValue: number },
  avgAnswer: number,
) => {
  const percentagePerValue = 100 / (question.endValue - question.startValue);
  return (avgAnswer - question.startValue) * percentagePerValue;
};
